(function ($) {
  $(document).ready(function () {
    if ($('.hm-logo-line').length) {
      $('.hm-logo-line').each(function () {
        const $block = $(this);
        const $slider = $block.find('.hm-logo-line__slider');

        if ($slider.length) {
          $slider.on('beforeStarting', function () {
            $block.addClass('m-run');
          }).marquee({
            speed: 10,
            direction: 'left',
            startVisible: true,
            pauseOnHover: false,
            duplicated: true
          });
        }
      });
    }
  });
})(jQuery);
